// extracted by mini-css-extract-plugin
module.exports = {"text":"AboutMeCommon_text__3mBqZ"};